import { SSN_VALIDATION_REGEX } from './constants';

export function isValidSsn(ssn) {
  return ssn && (ssn.match(SSN_VALIDATION_REGEX) || (/x/i.test(ssn) && ssn.length === 11));
}
